import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import Link from '../Link';

const BreadcrumItem = ({ lastBreadcrumbItem, link, title, hoverable }) => {
    const linkClassName =
        'leading-5 font-body font-thin text-small relative transition duration-300 ease-out group';

    return (
        <li>
            {!hoverable || lastBreadcrumbItem ? (
                <p className={cx(linkClassName, 'mb-0 inline-block cursor-default')}>{title}</p>
            ) : (
                <Link href={link} data-info={title} underline={false} className={linkClassName}>
                    {title}
                    <span className='absolute bottom-0 left-0 hidden h-px w-full origin-left transform bg-ui-black transition duration-300 ease-out group-hover:scale-100 md:scale-0 lg:block' />
                </Link>
            )}

            {lastBreadcrumbItem ? (
                ''
            ) : (
                <span className='inline-block px-2 font-body text-small font-thin leading-5'>
                    /
                </span>
            )}
        </li>
    );
};

const Breadcrumb = ({ breadcrumbs, className, style }) => {
    const wrapperClassName = cx(className, 'flex flex-wrap items-end');

    return (
        <ul className={wrapperClassName} style={style}>
            {breadcrumbs.map((b, index, { length }) => {
                return (
                    <Fragment key={index}>
                        <BreadcrumItem
                            title={b.title}
                            lastBreadcrumbItem={length - 1 == index}
                            hoverable={!!b.link}
                            index={index}
                            link={b.link}
                        />
                    </Fragment>
                );
            })}
        </ul>
    );
};

Breadcrumb.defaultProps = {};

Breadcrumb.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default Breadcrumb;
